import { useMemo } from "react";
import { InvoicesAvailableAction } from "@jugl-web/domain-resources/invoices/types";

interface UseAvailableActionsProps {
  variant: "task" | "customer" | "all";
  isGuest?: boolean;
}

export const useAvailableActions = ({
  variant,
  isGuest = false,
}: UseAvailableActionsProps): InvoicesAvailableAction[] => {
  return useMemo(() => {
    switch (variant) {
      case "task":
        if (isGuest) {
          return ["copy-url", "download-pdf"];
        }
        return [
          "copy-url",
          "download-pdf",
          "export-to-xlsx",
          "delete",
          "update",
          "convert-to-proforma",
          "convert-to-invoice",
          "convert-to-purchase-order",
        ];
      case "customer":
        if (isGuest) {
          return [];
        }
        return ["copy-url"];

      case "all":
        return [
          "copy-url",
          "download-pdf",
          "export-to-xlsx",
          "delete",
          "update",
          "convert-to-proforma",
          "convert-to-invoice",
          "convert-to-purchase-order",
        ];
      default:
        return [];
    }
  }, [isGuest, variant]);
};
